import { CompaniesSettings } from './components/CompaniesSettings';
import { LanguagePicker } from './components/LanguagePicker';

export const SettingsScreen = () => {
  return (
    <div className="width-100 flex-center-center-column-nowrap">
      <div className="page">
        <div className="flex-center-center-row-wrap gap-10">
          <LanguagePicker />
          <CompaniesSettings />
        </div>
      </div>
    </div>
  );
};
